/** The sections of the Transactions area: two are tabs of /transactions, two are pages of their own. */
export const TRANSACTION_SECTIONS = {
  ALL: 'all',
  RECURRING: 'recurring',
  RECIPIENTS: 'recipients',
  BATCH: 'batch'
} as const

/** The sections /transactions can show itself (the others open another page). */
export function isInPageSection(
  value: unknown
): value is typeof TRANSACTION_SECTIONS.ALL | typeof TRANSACTION_SECTIONS.RECURRING {
  return value === TRANSACTION_SECTIONS.ALL || value === TRANSACTION_SECTIONS.RECURRING
}
